// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2HiBR","header":"ReportDetails_header__3yVeg","title":"ReportDetails_title__6HMs2","left":"ReportDetails_left__280Q5"};